/* SPDX-FileCopyrightText: Copyright (c) 2026 NVIDIA CORPORATION & AFFILIATES. All rights reserved. */
/* SPDX-License-Identifier: Apache-2.0 */

nve-tree-node:not(:has(> [slot='content']))::part(_content) {
  display: none !important;
}

nve-tree-node:not(:has(> [slot='nodes']))::part(_nodes) {
  height: 0;
}

nve-tree-node:has(> [slot='nodes']):not([expanded])::part(_nodes) {
  height: 0;
}

nve-tree-node > nve-tree-node:state(is-expandable) {
  margin-inline-start: calc(-1 * var(--nve-ref-size-400));
  width: calc(100% + var(--nve-ref-size-400));
}

nve-tree-node > nve-tree-node:state(is-expandable):state(selectable-multi) {
  margin-inline-start: calc(-1 * var(--nve-ref-size-500));
  width: calc(100% + var(--nve-ref-size-500));
}

nve-tree-node:has(nve-tree-node:state(is-expandable))::part(_nodes) {
  padding-inline-start: var(--nve-ref-size-400);
}
